export const Config = {
  main_url: 'https://slim.stlordsinternationalpublicschool.com',
  mainpy_url: "https://python.stlordsinternationalpublicschool.com",
};
